import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CategoryMetaField, ProductCategory, ProvinceDiscount } from 'src/app/models/product-category.schema';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { ProductCategoryService } from 'src/app/services/product-category.service';
import { ProvincesService } from 'src/app/services/provinces.service';
import { CommanUsesService } from './../../services/comman-uses.service';

@Component({
  selector: 'app-product-category-form',
  templateUrl: './product-category-form.component.html',
  styleUrls: ['./product-category-form.component.scss']
})
export class ProductCategoryFormComponent implements OnInit {

  productCategoryForm: any;
  formValidationMsgs: any;
  productCategory: ProductCategory;
  productCategoryId: string|number = null;
  provinces: any[] = [];
  
  constructor(
    private productCategoryService: ProductCategoryService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private provincesService: ProvincesService,
    private fb: FormBuilder,
    private commanUsesService: CommanUsesService,
  ) { 
    this.handleProductCategoryForm();
  }

  async ngOnInit() { 
    try {
      this.productCategoryId = this.route.snapshot.paramMap.get('id');
      await this.getAllProvinces();
      if (this.productCategoryId) {
        this.productCategory = await this.productCategoryService.getProductCategory(Number(this.productCategoryId));
      }
      if (this.productCategory){
        this.patch();
        if(this.productCategory.categoryMetaFields){
          this.patchCategoryMetaFields(JSON.parse(this.productCategory.categoryMetaFields));
        }
      }
      else {
        this.productCategory = new ProductCategory();
      }
    } catch (error) {
      console.log("ERROR", error);
      this.commanUsesService.showSnackBar("Something went wrong on this page");
    }
  }

  handleProductCategoryForm(){
    this.productCategoryForm = new FormGroup(ProductCategory.validation());
    this.formValidationMsgs = ProductCategory.validationMessages;
  }

  patch(){
    ['categoryName', 'notes', 'aiPrompt'].forEach(param => {
      this.productCategoryForm.controls[param].setValue(this.productCategory[param]);
    });
    if(this.productCategory.provinceDiscounts.length > 0){
      this.patchProductCategoryProvinceDiscount();
    }
  }

  patchProductCategoryProvinceDiscount(){
    const control = <FormArray>this.productCategoryForm.get('provinceDiscounts');
    control.clear();
    if (!this.productCategory.provinceDiscounts || Array.isArray(this.productCategory.provinceDiscounts) && this.productCategory.provinceDiscounts.length == 0){
      this.productCategory.provinceDiscounts = [new ProvinceDiscount()];
    }
    this.productCategory.provinceDiscounts.forEach((f, index) => {
      control.push(this.patchValues(f, index));
    });
  }

  patchValues(provinceDiscounts: ProvinceDiscount, index: number) {
    let productCatProData = ProductCategory.provinceFormGroup();
    productCatProData.controls.province.setValue({ 
      id: provinceDiscounts?.province?.id, 
    });
    productCatProData.controls.discount.setValue(provinceDiscounts.discount || 0);
        
    return productCatProData;
  }

  get categoryMetaFields(): FormArray {
    return this.productCategoryForm.get('categoryMetaFields') as FormArray;
  }

  patchCategoryMetaFields(metaFieldsData: any[]) {
    const formArray = this.categoryMetaFields;
  
    // Clear existing fields
    formArray.clear();
  
    // Loop through the metaFieldsData and push into FormArray
    metaFieldsData.forEach(field => {
      formArray.push(new FormGroup({
        fieldName: new FormControl(field.fieldName),
        type: new FormControl(field.type),
      }));
    });
  }
  

  async onSubmit(){
    if(this.productCategoryForm.valid){
      let productCategory: ProductCategory = new FormGroupToObject().transform(this.productCategoryForm);
      productCategory.categoryMetaFields = productCategory.categoryMetaFields ? JSON.stringify(productCategory.categoryMetaFields) : null;
      let promiseResult: any;
      // console.log("productCategory", productCategory);
      // return
      if (this.productCategory['id']) {
        promiseResult = this.productCategoryService.updateProductCategory(this.productCategory['id'], productCategory);
      } else {
        promiseResult = this.productCategoryService.createProductCategory(productCategory);
      }
      let message: string = this.productCategory['id'] ? "Prodotti Categoria aggiornato" : "Prodotti Categoria creato";
      promiseResult.then(async (response: ProductCategory) => {
        this.productCategory = response;
        await this.showSnackBar(message);
        await this.router.navigate(['/product/categoria', response.id , 'edit']);
        this.patch();
      }).catch(async (error: any) => {
        await this.showSnackBar(error.error.message);
      });
    }
  }

  addCategoryMetaField() {
    const control = this.productCategoryForm.get('categoryMetaFields') as FormArray;
    control.push(new FormGroup(CategoryMetaField.validation()));
  }

  removeCategoryMetaField(index: number) {
    const control = this.productCategoryForm.get('categoryMetaFields') as FormArray;
    control.removeAt(index);
    if (control.length > 1) {
    }
  }

  async getAllProvinces(){
    try {
      this.provinces = await this.provincesService.getAllProvinces();
    } catch (error) {
      console.log("ERROR_IN_getAllProvinces");
    }
  }

  isProvinceOptionDisabled(item: any): boolean {
    let hasEmptyId = false;
    for (const provinces of this.productCategoryForm.value.provinceDiscounts) {
      if (provinces.province.id === item.id) {
        hasEmptyId = true;
      }
    }
    return hasEmptyId;
  }

  addProvince() {
    const control = <FormArray>this.productCategoryForm.get('provinceDiscounts');
    control.push(ProductCategory.provinceFormGroup());
  }

  
  removeProvince(index: number) {
    const control = <FormArray>this.productCategoryForm.get('provinceDiscounts');
    control.removeAt(index);
  }

  async showSnackBar(message: string) {
    this._snackBar.open(`${message}`, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    })
  }

}
